export default __webpack_public_path__ + "static/media/ap-card-phone.af122b5d.svg";